/** Alert tones: "message" (staff chime) and "ceo" (puppet / system alert). Unlocked on the first tap so browsers allow playback. */
const SRC = { message: "/nsconnect/sounds/nexsecure_message.wav?v=2", ceo: "/nsconnect/sounds/nexsecure_ceo.wav?v=2" };
const players = {};
let unlocked = false;
let lastPlay = 0;

/** Vibration patterns [vibrate, pause, vibrate, ...] ms — mirrored in backend/connect_push.py and the Android MainActivity. */
export const VIBES = [
  { id: "gentle", label: "Gentle", hint: "Two short buzzes", pattern: [90, 50, 90] },
  { id: "double", label: "Double tap", hint: "Two firm taps", pattern: [150, 100, 150] },
  { id: "long", label: "Long", hint: "One long buzz", pattern: [500] },
  { id: "heartbeat", label: "Heartbeat", hint: "Two quick, one long", pattern: [100, 60, 100, 60, 350] },
  { id: "off", label: "Off", hint: "No vibration for messages", pattern: [] },
];
export const CEO_VIBE = [200, 80, 200, 80, 400];
export const vibeKey = () => localStorage.getItem("nxc_vibe") || "gentle";
export const setVibeKey = (id) => localStorage.setItem("nxc_vibe", id);
export const vibePattern = (id) => (VIBES.find((v) => v.id === id) || VIBES[0]).pattern;

const get = (kind) => {
  if (!players[kind]) { const a = new Audio(SRC[kind] || SRC.message); a.preload = "auto"; a.volume = 1; players[kind] = a; }
  return players[kind];
};

/** 09:30–17:30 IST on a working day (server-confirmed per staff member) the alert tone cannot be muted. */
const istNow = () => new Date(Date.now() + (330 + new Date().getTimezoneOffset()) * 60000);
export const setWorkDay = (day) => { if (day) localStorage.setItem("nxc_work_day", day); else localStorage.removeItem("nxc_work_day"); };
export const soundLocked = () => {
  const n = istNow();
  const day = `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`;
  const hm = `${String(n.getHours()).padStart(2, "0")}:${String(n.getMinutes()).padStart(2, "0")}`;
  return localStorage.getItem("nxc_work_day") === day && hm >= "09:30" && hm < "17:30";
};
export const soundEnabled = () => soundLocked() || localStorage.getItem("nxc_sound") !== "off";
export const setSoundEnabled = (on) => { if (!on && soundLocked()) return false; localStorage.setItem("nxc_sound", on ? "on" : "off"); return true; };

export const unlockSound = () => {
  if (unlocked) return;
  unlocked = true;
  Object.keys(SRC).forEach((k) => { const a = get(k); a.muted = true; a.play().then(() => { a.pause(); a.currentTime = 0; a.muted = false; }).catch(() => { a.muted = false; }); });
};

/** CEO alerts always use the strong fixed pattern; staff messages use the member's chosen pattern. */
export const vibrateFor = (kind = "message", pattern) => {
  if (!navigator.vibrate) return;
  const p = pattern || (kind === "ceo" ? CEO_VIBE : vibePattern(vibeKey()));
  if (p.length) navigator.vibrate(p);
};

/** Mute only silences the tone — the phone still vibrates so no message is missed. */
export const playTone = (kind = "message", force = false) => {
  const now = Date.now();
  if (!force && now - lastPlay < 1200) return;
  lastPlay = now;
  vibrateFor(kind);
  if (!force && !soundEnabled()) return;
  const a = get(kind);
  a.currentTime = 0;
  a.play().catch(() => {});
};

/** Wire once: unlock on first gesture, play when the service worker or the native push plugin reports an alert. */
export const initSound = () => {
  ["pointerdown", "keydown", "touchstart"].forEach((ev) => window.addEventListener(ev, unlockSound, { once: true, passive: true }));
  navigator.serviceWorker?.addEventListener("message", (e) => { if (e.data?.type === "nxc-push") playTone(e.data.sound); });
};
